import { theme } from '@lojinha/design-system'
import { PurchasesVariants } from '../../core/purchase-variants'
import { t } from '../../dictionary'
import { DayCalendarVariants } from '../day-calendar'

export const purchaseCardStyles: Record<
  PurchasesVariants,
  {
    color: keyof typeof theme.colors
    title: string
    dayCalendarVariant: DayCalendarVariants
  }
> = {
  [PurchasesVariants.MyPurchases]: {
    color: 'acaiDark',
    title: t.waitingPaymentOrder,
    dayCalendarVariant: DayCalendarVariants.secondary,
  },
  [PurchasesVariants.Approved]: {
    color: 'blueberryDark',
    title: t.approvedOrder,
    dayCalendarVariant: DayCalendarVariants.primary,
  },
  [PurchasesVariants.Returned]: {
    color: 'acaiLight',
    title: t.returnedOrder,
    dayCalendarVariant: DayCalendarVariants.primary,
  },
  [PurchasesVariants.WaitingPayment]: {
    color: 'acaiDark',
    title: t.waitingPaymentOrder,
    dayCalendarVariant: DayCalendarVariants.secondary,
  },
  [PurchasesVariants.WaitingAuthorization]: {
    color: 'acaiDark',
    title: t.waitingAuthorization,
    dayCalendarVariant: DayCalendarVariants.secondary,
  },
  [PurchasesVariants.Canceled]: {
    color: 'error',
    title: t.refusedPayment,
    dayCalendarVariant: DayCalendarVariants.error,
  },
  [PurchasesVariants.Done]: {
    color: 'black',
    title: t.deliveredOrder,
    dayCalendarVariant: DayCalendarVariants.info,
  },
  [PurchasesVariants.CanceledAfter3Days]: {
    color: 'black',
    title: t.refusedPayment,
    dayCalendarVariant: DayCalendarVariants.info,
  },
}
